import { render, staticRenderFns } from "./listAvatar.pug?vue&type=template&id=a1c7e6d6&lang=pug&external"
import script from "./listAvatar.js?vue&type=script&lang=js&external"
export * from "./listAvatar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c7e6d6')) {
      api.createRecord('a1c7e6d6', component.options)
    } else {
      api.reload('a1c7e6d6', component.options)
    }
    module.hot.accept("./listAvatar.pug?vue&type=template&id=a1c7e6d6&lang=pug&external", function () {
      api.rerender('a1c7e6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/list/modules/avatar/index.vue"
export default component.exports